<ion-card>
    <div class="overcard-title">
        KOSTEN PER MAAND
    </div>
    <ion-row>
        <ion-col size="12" *ngIf="household">
            <ngx-line-chart
                    [lineChartData]="lineChartData"
                    [lineChartLabels]="lineChartLabels"
                    [maxValue]="maxValue"
            ></ngx-line-chart>
        </ion-col>
        <div *ngIf="!household">
            {{errorMessage}}
        </div>
    </ion-row>
</ion-card>
